module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "x-filter-condition",
    class: 'x-filter-condition-' + _vm.getConditionType()
  }, [_vm._v("\n    " + _vm._s(_vm.getConditionSummary()) + "\n    "), _c('i', {
    staticClass: "x-filter-condition-remove icon yule-icon-close-small",
    on: {
      "click": function($event) {
        return _vm.removeCondition()
      }
    }
  })]), _vm._v(" "), (_vm.isLast == false) ? _c('span', {
    staticClass: "x-filter-operator",
    class: 'x-filter-operator-' + _vm.operator
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c8452f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/XFilterCondition.vue
// module id = 1934
// module chunks = 0